import type { Owner } from "../../pages/linehaul/shared/filter-controls/ownerFilter.type";

/** UC/CC OFD owner-avatar filter options keyed by scenario (add keys per test case as needed). */
export const mockUcccOfdOwnerFilterOptions = {
  default: [
    {
      id: "1",
      name: "John Doe",
    },
    {
      id: "2",
      name: "Jane Smith",
    },
    {
      id: "3",
      name: "Barbara Smith",
    },
    {
      id: "4",
      name: "Michael Chen",
    },
    {
      id: "5",
      name: "Unassign",
    },
  ],
} satisfies Record<string, Owner[]>;

export const mockUcccOfdEditOwnerDialogOptions = {
  default: {
    suggested: [
      {
        id: "1",
        name: "Unassign",
      },
      {
        id: "2",
        name: "Jane Smith",
      },
      {
        id: "3",
        name: "Barbara Smith",
      },
    ],
    available: [
      {
        id: "4",
        name: "Michael Chen",
      },
      {
        id: "5",
        name: "Sarah Williams",
      },
    ],
  },
} satisfies Record<string, { suggested: Owner[]; available: Owner[] }>;
